import React from 'react';
import Topbar from '../Components/Topbar'
import MapComponent from '../Components/MapComponent';

function EventMap() {
  return (
    <div className="bg-[#F7F8FC] w-[100%] overflow-y-scroll rounded-xl">
      <Topbar/>
      <div className="bg-white px-[3%] mx-[8%] pt-[1%] pb-[3%] mb-[5%] mt-[2%]">
        <div className="mt-[15px] text-[28px] pt-[10px] mx-[1%]">
            <p className="text-black font-semibold ml-[0%] pb-[0px]">Event Map</p>
            <p className="text-black italic font-light ml-[0%] pb-[15px] text-[20px]">Click on a marker to see event details</p>
        </div>
            <MapComponent/>
      </div>
    </div>
  );
}

export default EventMap;
